
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../helper/api";
import { setCookies } from "../../helper/utils";
import { toast } from "react-toastify";

export const userLocation = createAsyncThunk("user/userLocation", async (payload) => {
    // "token": "abc123tokenxyz"
  const response = await api.post("user/user-location", payload);

  return response.data;
});

const userLocationSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  extraReducers: (builder) => {
    builder
      .addCase(userLocation.pending, (state) => {
       
        state.loading = true;
      })
      .addCase(userLocation.fulfilled, (state, action) => {
        
        // setCookies('token', action.payload.data.data.token)
        // setCookies('role', action.payload.data.data.role)
       
        state.loading = false;
        
        state.data = action.payload.data;
      })
      .addCase(userLocation.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default userLocationSlice.reducer;
